// extracted by mini-css-extract-plugin
export default {"report-history":"ReportHistoryDashboard_report-history__8NkC5","show-all-reports-button":"ReportHistoryDashboard_show-all-reports-button__-5s7r"};